import React from 'react';
// import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './LeasingCars.css';

class LeasingCars extends React.Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
  };
  static defaultProps = {};
  render() {
    const { content } = this.props;
    return (
      <div className={s.root}>
        <div className={s.container} dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }
}

export default withStyles(s)(LeasingCars);



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingCars/LeasingCars.js